import React, { useState, useEffect } from "react"
import { Card, CardBody, Row, Col, Button } from "reactstrap"
import { history } from "app-history"
import errorImg from "assets/images/pages/error.svg"

const Error500 = () => {
  const [countdown, setCountdown] = useState(5)

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(countdown - 1)
    }, 1000)
    if (countdown === 0) history.push('/auth')
    return () => clearInterval(interval)
  }, [countdown])

  return (
    <Row className="m-0">
      <Col sm="12">
        <Card className="auth-card bg-transparent shadow-none rounded-0 mb-0 w-100">
          <CardBody className="text-center">
            <img
              src={errorImg}
              alt="ErrorImg"
              className="img-fluid align-self-center"
            />
            <h1 className="font-large-2 my-1">500 - Server Error!</h1>
            <p className="pt-2 mb-0">
              Something went wrong, but no worries, someone has been alerted, we will fix this right away!
            </p>

            <p className="pt-2 mb-0">
              If this issue persists, you can email us at&nbsp;
              <a
                className="text-bold-600"
                href={`mailto:admin@vitaverify.me?subject=Page Not Found Error`}>
                admin@vitaverify.me
              </a>
            </p>
            <p className="pt-2 mb-0">
              <b>
                Automatic redirect in {countdown} second{(countdown !== 0 && countdown !== 1) && 's'}
              </b>
            </p>
            <Button color="primary mt-2" onClick={() => history.push('/auth')}>
              Back to Home
            </Button>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}
export default Error500
